import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_CHOICE } from "./abstract/choiceAbstract";
import { moveChoiceFlatLogic } from "./moveChoiceFlat";

const _action = `${ACTION_PREFIX_CHOICE}_remove`;
const _header = `Remove parameter`;

export const removeChoice = (root, id, keep = false) => {
  const _payload = removeChoiceLogic(root, id, keep);

  logger.logAction(_action, _payload, ACTION_PREFIX_CHOICE);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const removeChoiceLogic = (root, id, keep) => {
  const { data: _node, index: _index } = getNodeById(root, id);

  if (!_node) {
    throw new Error ('Choice to remove not found');
  }

  const { data: _nodeParent } = getNodeById(root, pathUtils.getIdParent(id));

  const _nodeBackup = systemUtils.createDeepCopy(_node);

  const _uuidChildren = preserveNodes(root, _node, _nodeParent, _index, keep);

  removeNode(_nodeParent, logicFind(_nodeParent, id));

  if (!nodeUtils.hasChildren(_nodeParent)) {
    nodeUtils.setChoices(_nodeParent, null);
  }

  return generatePayload(_nodeBackup, _index, _nodeParent, _uuidChildren);
};

const logicFind = (node, id) => {
  const _choices = nodeUtils.getChoices(node);
  const _occurrences = [];

  for (let i = 0; i < _choices.length; i++) {
    if (nodeUtils.getID(_choices[i]) === id) {
      _occurrences.push(i);
    }
  }

  return _occurrences;
};

const preserveNodes = (root, node, nodeParent, index, keep) => {
  const _preserved = [];

  if (keep) {
    const _children = nodeUtils.getChoices(node);

    const fun = (e) => {
      _preserved.push(nodeUtils.getUUID(e));

      const _index = index + _preserved.length;
      moveChoiceFlatLogic(root, nodeUtils.getID(e), nodeUtils.getID(nodeParent), _index);
    };

    _children.forEach(fun);
  }

  return _preserved;
};

const removeNode = (elementParent, occurrences) => {
  const _choices = nodeUtils.getChoices(elementParent);

  for (let i = 0; i < occurrences.length; i++) {
    _choices.splice(occurrences[i] - i, 1);
    nodeUtils.setChoices(elementParent, _choices);
  }
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, nodeParent, uuidChildren) => {
  const _payload = {
    group: ActionGroupTypes.DELETE,
    status: nodeUtils.getName(node) ? ActionStatusTypes.SUCCESS : ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node),
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
  };

  if (uuidChildren.length > 0) {
    _payload["uuidChildren"] = uuidChildren;
  }

  return systemUtils.createDeepCopy(_payload);
};

const generatePayloadDescription = (node) => {

    return `Delete choice '${nodeUtils.getName(node)}'.`;
}